import memoized from '../memoized';

const IS_DIGITS = /[^0-9]/g;

export const onlyDigits = value => value.replace(IS_DIGITS, '').trim();
export const isDigit = memoized(message => value =>
  onlyDigits(value) === value.trim() ? undefined : message || true,
);
